import React from "react";
import PropTypes from "prop-types";
import { Col, Row, Container } from "react-bootstrap";
import { IoAlertCircle } from "react-icons/io5";
import { FaTag } from "react-icons/fa";
import Select from "react-select";
import { MdSend } from "react-icons/md";
import StatusBadge from "../../shared/StatusBadge";
import Patient from "../../shared/Patient";
import PriorityBadge from "../../shared/PriorityBadge";
import * as CONST from "../../helpers/Constants";
import TaskField from "./TaskField";
import TaskTags from "./TaskTags";
import * as API from "../../api";
import { Settings } from "../../helpers/Contexts";

const propTypes = {
  task: PropTypes.object.isRequired,
  formHandler: PropTypes.func.isRequired,
  patient: PropTypes.object,
  agents: PropTypes.object,
  messages: PropTypes.object,
};

TaskHeader.prototype = propTypes;
export default function TaskHeader(props) {
  const settings = React.useContext(Settings);
  const [editTags, setEditTags] = React.useState(false);
  const [notified, setNotified] = React.useState(false);

  const currentTagValues = [
    ...props.task.tags.map((i) => {
      return {
        value: i,
        label: i.replaceAll("-", " "),
      };
    }),
  ];

  const renderAgentNotes = (
    <div>
      <div className="header-field">
        <label>Waiting Label </label>
        <i className="pr1">{props.task.waitingLabel}</i>

        <TaskField
          optionValues={CONST.TASK_LABELS}
          fieldType="select"
          value={props.task.waitingLabel}
          description={"Waiting status (pcp, patient)"}
          attribute={"label"}
          name={"label"}
          formHandler={props.formHandler}
          data={props}
        />
        <br />
      </div>
      <div className="header-field">
        <label>Agent Note </label>
        <i className="pr1">{ props.task.agentNoteAddedOn} - {props.task.agentNote} - { props.task.agentNoteAddedBy }</i>
        <TaskField
          fieldType="text"
          value={props.task.agentNote}
          attribute={"agent_note"}
          description={"Custom note from the agent"}
          name={"agent_note"}
          data={props}
          formHandler={props.formHandler}
        />
      </div>
      <div className="header-field">
        {!notified && (
          <>
            <a
              className="btn btn-default"
              onClick={(e) => {
                setNotified(true);
                API.notifyTask(props.task.id, {});
              }}
            >
              <MdSend size={20} className="m-r-md" />
              <span style={{ marginRight: "20px", top: "-4px", position: "relative" }}>
                Notify Support Agents
              </span>
            </a>
          </>
        )}
        {notified && (
          <>
            <b>Notified!</b>
          </>
        )}
      </div>
      <div className="header-field">
      {
        props.task.closed_by && (<>
          <label>Closed by: { props.task.closed_by } at { props.task.closed_at }</label>
        </>)
      }
      </div>
    </div>
  );

  const renderSelectTags = (
    <div className="select-tag-list">
      <div className="edit-tag">
        <FaTag className="tag-icon" />
        <a className="ml5" onClick={(e) => setEditTags(!editTags)}>
          {!editTags ? (
            <>
              Edit Tags
              <i className="ml5 fa fa-edit blue-text" />
            </>
          ) : (
            "Cancel"
          )}
        </a>
      </div>
      {editTags && (
        <div className="py1">
          <Select
            defaultValue={currentTagValues}
            placeholder="add a tag"
            options={[
              ...settings.tags.map((i) => {
                return { value: i, label: i.replaceAll("-", " ") };
              }),
            ].concat([
              ...settings.support_agent_initials_tags.map((i) => {
                return { value: i, label: i.replaceAll("-", " ") };
              }),
            ])}
            onChange={(e) => {
              props.formHandler({
                task: {
                  id: props.task.id,
                  tag_list: e.map((i) => i.value),
                },
              });
            }}
            isMulti
            name="task-tags"
          />
        </div>
      )}
    </div>
  );
  return (
    <>
      <Container id="header-bar">
        <Row>
          <Col sm={12} className="pad20">
            <h3>
              <b>
                <StatusBadge status={props.task.status} className="header-status" />
                {" #" + props.task.id + ": " + props.task.label + "  "}
                {props.task.alert && (
                  <span className="error">
                    <IoAlertCircle className="error-icon error" />
                    {props.task.alert}
                  </span>
                )}
                {props.task.priority && (
                  <b id="float-r">
                    {"PRIORITY "}
                    <PriorityBadge priority={props.task.priority} />
                  </b>
                )}
              </b>
            </h3>
            <h4>
              {props.task.cprId && <b>CPR #{props.task.cprId}: </b>} {props.task.visitType}
            </h4>
            <TaskTags tags={currentTagValues} />
          </Col>
        </Row>
        <Row className="flex">
          <Col md={3} sm={6} className="bt py2">
            {renderSelectTags}
            {props.agents}
            {renderAgentNotes}
          </Col>

          {props.messages}
        </Row>

        <Row className="pad20 bt5 bb mt05">
          <Patient patient={props.patient} />
        </Row>
      </Container>
    </>
  );
}
